import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Terms of Service - Logardt Group</title>
      </Helmet>
      <div className="min-h-screen" style={{ background: '#FAFAFA', padding: '40px 7.6923%' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 bg-transparent border px-6 py-3 cursor-pointer mb-10 text-base transition-colors hover:bg-opacity-10"
            style={{ 
              borderColor: '#E5A93D',
              color: '#0D2C22',
              borderRadius: '0px'
            }}
          >
            <ArrowLeft size={20} />
            Back to Home
          </button>

          <h1 className="mb-10" style={{ color: '#0D2C22', fontSize: '48px', fontFamily: 'Georgia, serif' }}>
            Terms of Service
          </h1>

          <div style={{ color: '#0D2C22', fontSize: '16px', lineHeight: '1.8' }}>
            <p className="mb-5" style={{ color: '#666666' }}>
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              1. Acceptance of Terms
            </h2>
            <p className="mb-5">
              By accessing and using the services provided by Logardt Group KB ("we," "us," or "our"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              2. Services Provided
            </h2>
            <p className="mb-5">
              Logardt Group KB provides consulting services including but not limited to:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '20px' }}>
              <li>AI Website Building (Landing Pages and Fullstack Applications)</li>
              <li>Language Services (Translation, Transcription, Proofreading, Editing, Voice Over)</li>
              <li>Flowmingo AI Recruiter Service</li>
            </ul>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              3. Pricing and Payment
            </h2>
            <p className="mb-5">
              All prices are quoted excluding VAT unless otherwise stated. Final pricing may vary depending on project complexity and specific requirements. Payment terms will be agreed upon before project commencement.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              4. Project Revisions
            </h2>
            <p className="mb-5">
              Unless otherwise agreed, our website building services include 2 rounds of revisions. Additional revisions may incur extra charges.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              5. Intellectual Property
            </h2>
            <p className="mb-5">
              Upon full payment, clients receive ownership of the final deliverables. We retain the right to showcase completed projects in our portfolio unless otherwise agreed in writing.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              6. Confidentiality
            </h2>
            <p className="mb-5">
              We respect the confidentiality of all client information and will not disclose sensitive business information to third parties without explicit consent.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              7. Limitation of Liability
            </h2>
            <p className="mb-5">
              Logardt Group KB shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services. Our total liability shall not exceed the amount paid for the specific service in question.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              8. Termination
            </h2>
            <p className="mb-5">
              Either party may terminate a service agreement with written notice. Termination terms and any applicable refunds will be handled according to the specific service agreement.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              9. Changes to Terms
            </h2>
            <p className="mb-5">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to this page.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              10. Governing Law
            </h2>
            <p className="mb-5">
              These Terms of Service shall be governed by and construed in accordance with the laws of Sweden.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              Contact Information
            </h2>
            <p style={{ marginBottom: '40px' }}>
              For questions regarding these Terms of Service, please contact us through the contact form on our website.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;